// Dependencies
import React from "react";

// Styles
import { DividerContainer } from "./Divider.styles";

const Divider = () => {
	return <DividerContainer></DividerContainer>;
};

export default Divider;
